import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

/** The task comments page lists the whole customer's comments; the discipline opens it filtered to itself, as the
 *  legacy discipline menu did. */
export const buildDisciplineTaskCommentsUrl = (disciplineId: number | string): string | null => {
  const path = resolveUrl(AppRoute.DisciplinesTaskComments, { id: disciplineId })
  if (!path) return null

  const search = new URLSearchParams({ 'discipline_id[0]': String(disciplineId) })
  return `${path}?${search.toString()}`
}
